/* eslint-disable react/prop-types */
// Imports
import React from "react";
import { BookmarkButton } from "../../RecBookmarkButton/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import { getNormalisedUrl, gtmPush } from "../../utils/helpers";

const RecCardHero = ({
    id,
    image,
    thumbnail,
    name,
    summary,
    url,
    tags,
    recommended = true,
    can_bookmark,
}) => {
    const { windowWidth } = useQuiz();
    const bookmarkData = {
        id,
        thumbnail,
        name,
        summary,
        url,
        tags,
        can_bookmark,
    };

    // filter empty tags
    const tagsArray = [...tags].filter(Boolean);

    const handleLinkClick = () => {
        gtmPush({
            event: "recommendation_interaction",
            interaction_type: "click",
            component_name: "rec-card",
            click_text: "Read recommendation",
            click_url: getNormalisedUrl(url),
        });
    };

    return (
        <>
            <div className="rec-card-hero">
                {recommended && (
                    <span className="pills pills--rec rec-card-hero__pill--rec">
                        Recommendation
                    </span>
                )}
                {image && (
                    <div className="rec-card-hero__image">
                        <img src={image} alt="" />
                    </div>
                )}
                <div className="rec-card-hero__details">
                    <div className="rec-card-hero__pills-wrapper">
                        <div className="rec-card-hero__pills">
                            {recommended && (
                                <span className="pills pills--rec rec-card-hero__pill">
                                    Recommendation
                                </span>
                            )}
                            {tagsArray.map((tags, index) => (
                                <span
                                    key={index}
                                    className="pills rec-card-hero__pill"
                                >
                                    {tags}
                                </span>
                            ))}
                        </div>
                        {can_bookmark && <BookmarkButton data={bookmarkData} />}
                    </div>

                    <div className="rec-card-hero__content">
                        <div className="rec-card-hero__bodycopy">
                            {name && (
                                <h3 className="rec-card-hero__title">{name}</h3>
                            )}
                            {summary && (
                                <p
                                    className="rec-card-hero__desc"
                                    dangerouslySetInnerHTML={{
                                        __html: summary.replace(
                                            /(<? *script)/gi,
                                            "illegalscript",
                                        ),
                                    }}
                                ></p>
                            )}
                        </div>
                        {url && (
                            <div className="rec-card-hero__link-wrapper">
                                <a
                                    className="rec-card-hero__link"
                                    href={url}
                                    rel="noreferrer"
                                    target="_blank"
                                    aria-label={`Read recommendation - ${name}`}
                                    onClick={handleLinkClick}
                                >
                                    Read{" "}
                                    {windowWidth > 997 ? "recommendation" : ""}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecCardHero;
